import React, { memo } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid } from 'recharts'

const BAR_COLORS = ['#717AFF', '#717AFF', '#949BFF', '#A3A9FF', '#AFB4FF', '#BCC0FF', '#C7CBFF']

const CustomTooltip = memo(({ active, payload, coordinate }) => {
  if (active && payload && payload.length && coordinate) {
    const value = Math.round(payload[0].value)
    
    const tooltipWidth = 80
    const leftPosition = Math.max(5, coordinate.x - tooltipWidth / 2)
    const topPosition = coordinate.y - 45
    
    return (
      <div style={{
        position: 'absolute',
        left: leftPosition,
        top: topPosition,
        pointerEvents: 'none',
        zIndex: 30
      }}>
        <div className="bg-gray-900 text-white px-3 py-2 rounded-lg shadow-lg relative">
          <p className="text-sm font-medium whitespace-nowrap m-0">
            {value}
          </p>
        </div>
      </div>
    )
  }
  return null
})

CustomTooltip.displayName = 'CustomTooltip'

const getXAxisProps = (selectedPeriod) => {
  const baseProps = {
    dataKey: "label",
    axisLine: false,
    tickLine: false,
    tick: { fill: '#6B7280', fontSize: 11, fontWeight: 500 },
    dy: 10
  }

  if (selectedPeriod === 'This Month' || selectedPeriod === 'Last Month') {
    return {
      ...baseProps,
      interval: 0,
      angle: -45,
      textAnchor: 'end',
      height: 60,
      tick: { fill: '#6B7280', fontSize: 10, fontWeight: 500 }
    }
  }

  return baseProps
}

const ActivityBarChart = memo(({ data, selectedPeriod }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart
      data={data}
      barSize={selectedPeriod?.includes('Month') ? 12 : 35}
      margin={{
        top: 50,
        right: 30,
        left: -25,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
      <XAxis {...getXAxisProps(selectedPeriod)} />
      <YAxis
        axisLine={false}
        tickLine={false}
        tick={{ fill: '#6B7280', fontSize: 12 }}
        tickFormatter={(value) => Math.round(value)}
        allowDecimals={false}
      />
      <Tooltip 
        content={<CustomTooltip />}
        cursor={false}
        isAnimationActive={false}
        wrapperStyle={{ outline: 'none' }}
      />
      <Bar dataKey="value" radius={[6, 6, 0, 0]}>
        {data.map((_, index) => (
          <Cell key={`cell-${index}`} fill={BAR_COLORS[index % BAR_COLORS.length]} />
        ))}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
))

ActivityBarChart.displayName = 'ActivityBarChart'

export default ActivityBarChart